import { Box, Button, Card, RadioChip, Typography } from '@capitalise/ui-design-system';
import { billingOptionsRadios } from 'enums/partner-referral-types';

export interface IRadioOptionsGroupsProps {
  partnerReferral: string;
  setPartnerReferral: Function;
  copyLinkCallback: Function;
  showRadios: boolean;
  toggleShowRadios: Function;
}

const RadioOptionsGroups = ({
  partnerReferral,
  setPartnerReferral,
  copyLinkCallback,
  showRadios,
  toggleShowRadios,
}: IRadioOptionsGroupsProps) => {
  return (
    <>
      {showRadios ? (
        <Box display="flex" flexDirection="column" gridGap="3xsmall">
          {Object.entries(billingOptionsRadios.values).map(([key, value]) => {
            return (
              <RadioChip
                key={key}
                label={value.description}
                checked={key === partnerReferral}
                onChange={() => {
                  setPartnerReferral(key);
                }}
                title={value.title}
                variant={'card'}
              />
            );
          })}
          <Button
            baseColor="green"
            fullWidth
            onClick={() => {
              toggleShowRadios();
              copyLinkCallback();
            }}
          >
            Generate referral link
          </Button>
        </Box>
      ) : (
        <>
          <Card backgroundColor="grey-25" p="xsmall">
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Typography size="heading-16" color="grey-900">
                {billingOptionsRadios.values[partnerReferral].title}
              </Typography>
              <Button baseColor="green" onClick={() => toggleShowRadios()} variant="text">
                Change
              </Button>
            </Box>
            <Typography size="body-16" color="grey-700">
              {billingOptionsRadios.values[partnerReferral].description}
            </Typography>
          </Card>
        </>
      )}
    </>
  );
};

export default RadioOptionsGroups;
